import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.css';
import { Provider } from 'jotai';
import { store } from './atomstore/store';
import { useHydrateAtoms } from 'jotai/utils';
import { queryClientAtom } from 'jotai-tanstack-query';
import ChildSelectModal from './components/common/ChildSelectModal';
import AppUpdateModal from './components/common/AppUpdateModal';
import { setUserState } from './atomstore/serviceAtoms';
import App from './App';
import NotificationService from './components/common/NotificationService';
import manifest from './manifest.json';
import { restoreAppUpdateModalIfNeeded } from './utils/appUpdate';

// Clear all localStorage and sessionStorage when a new app version is detected.
// Runs synchronously before React mounts so no stale state ever reaches the app.
const STORED_VERSION_KEY = 'app_build_version';
const currentVersion = manifest.version;
const storedVersion = localStorage.getItem(STORED_VERSION_KEY);

if (storedVersion !== currentVersion) {
    console.log(`[version-guard] Version changed: ${storedVersion} → ${currentVersion}. Clearing storage.`);
    localStorage.clear();
    sessionStorage.clear();
    if ('caches' in window) {
        caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key))));
    }
    localStorage.setItem(STORED_VERSION_KEY, currentVersion);
}

restoreAppUpdateModalIfNeeded();

const queryClient = new QueryClient();
const HydrateAtoms = ({ children }) => {
    useHydrateAtoms([[queryClientAtom, queryClient]])
    return children
}
const root = ReactDOM.createRoot(document.getElementById('root'));

const localUser = localStorage.getItem("userstate");
if (localUser) setUserState(JSON.parse(localUser));
root.render(
    <Provider store={store} >
        <QueryClientProvider client={queryClient}>
            <HydrateAtoms>
                <ChildSelectModal />
                <AppUpdateModal />
                <NotificationService />
                <App />
            </HydrateAtoms>
        </QueryClientProvider>
    </Provider>
);